// De editorial-videoblokken zijn overgenomen van iliabeauty.com, dat een eigen <video-responsive>
// component gebruikt. Dit is onze eigen, minimale implementatie: HLS-bron weghalen voor browsers
// die dat niet spelen, poster/eerste beeld laden, en autoplay pas als het blok in beeld staat.
// Bedieningsknoppen blijven staan (WCAG 2.2.2: bewegend beeld moet te pauzeren zijn).
(() => {
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  class IliaVideoResponsive extends HTMLElement {
    connectedCallback() {
      const video = this.querySelector('video');
      if (!video || this.dataset.iliaInit) return;
      this.dataset.iliaInit = '1';
      if (!video.canPlayType('application/vnd.apple.mpegurl')) {
        for (const source of this.querySelectorAll('source')) {
          if (/mpegurl/i.test(source.type) || /\.m3u8(\?|$)/i.test(source.src)) source.remove();
        }
      }
      if (!this.querySelector('source')) return;
      if (video.preload === 'none') video.preload = 'metadata';
      const autoplay = video.hasAttribute('data-autoplay') && !reduceMotion;
      if (autoplay) {
        video.muted = true;
        video.playsInline = true;
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(entries => {
            for (const entry of entries) {
              if (entry.isIntersecting) video.play().catch(() => {});
              else video.pause();
            }
          }, { threshold: 0.25 }).observe(video);
        }
      }
      if (this.hasAttribute('toggle-on-click')) {
        this.addEventListener('click', event => {
          if (event.target.closest('a,button') || event.target === video && video.controls) return;
          video.paused ? video.play().catch(() => {}) : video.pause();
        });
      }
      video.load();
    }
  }
  if (!customElements.get('video-responsive')) customElements.define('video-responsive', IliaVideoResponsive);
})();
